import React from 'react'
import { ToastContainer as DefaultContainer, toast } from 'react-toastify'

export default class ToastContainer extends React.Component {
  render () {
    return (
      <DefaultContainer
        position={toast.POSITION.BOTTOM_LEFT}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        closeButton={false}
        rtl={false}
        draggable
        enableMultiContainer
        {...this.props}
      />
    )
  }
}
